import axios from 'axios'
import store from '@/store/store'

export default () => {
  return axios.create({
    baseURL: process.env.API_ROOT + '/v1/',
    headers: {
      Authorization: `Bearer ${store.state.token}`
    }
  })
}



// WEBPACK FOOTER //
// ./src/services/Api.js